<div class="btn btn-primary ld-ext-right" (click)="toggleLoading()">
  Click Me
  <div class="ld ld-ring ld-spin" [class.running]="isLoading"></div>
</div>
